module.exports = __webpack_public_path__ + "img/tu01.28042fbf.png";